export const emailErrorMessage = "Enter a valid email.";

export const passwordErrorMessage =
  "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter and one number.";
